import {
  BaseFullSchema_OLD,
  BaseRefSchema,
  BaseCreateSchema,
  BaseUpdateSchema,
  IdAsUUID,
  PaginatedResponse,
} from "./common/commonTypes";
import { EmployeeRef } from "./personTypes";
import { TypedSelectOption } from "./common/selectOptions";

export type UserRole = "admin" | "manager" | "user";
export const UserRoles = ["admin", "manager", "user"];

export interface UserFull extends BaseFullSchema_OLD {
  first_name: string;
  last_name: string;
  email: string;
  role: UserRole;
  employee: EmployeeRef;
  is_active: boolean;
  is_verified: boolean;
  is_superuser: boolean;
}
export interface UserRef extends BaseRefSchema {
  first_name: string;
  last_name: string;
  role: UserRole;
  is_active: boolean;
}
export type UserOption = TypedSelectOption<
  "user",
  {
    first_name: string;
    last_name: string;
    email: string;
    role: UserRole;
    employee_id: IdAsUUID;
    is_active: boolean;
    is_verified: boolean;
    is_superuser: boolean;
  }
>;

export interface UserCreate extends BaseCreateSchema {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  role: UserRole;
  is_superuser: boolean;
  employee_id: IdAsUUID;
}

export interface UserUpdate extends BaseUpdateSchema {
  first_name?: string;
  last_name?: string;
  email?: string;
  password?: string;
  role?: UserRole;
  is_active?: boolean;
  is_superuser?: boolean;
  is_verified?: boolean;
  employee_id?: IdAsUUID;
}

export type PaginatedUserResponse = PaginatedResponse<UserFull>;
